export function handleCheckboxFilter({
  getValues,
  reset,
  setValue,
  toggleFunction,
  fieldToClear,
  clearCallback,
}) {
  const currentFormState = getValues();
  toggleFunction();

  setTimeout(() => {
    reset({
      ...currentFormState,
      [fieldToClear]: '',
    });

    const checkboxFlag = `by${fieldToClear.charAt(0).toUpperCase()}${fieldToClear.slice(1)}`;
    setValue(checkboxFlag, false);

    clearCallback?.();
  }, 0);
}
